import { Grid } from "@mui/material";
import DataHubTable from "./components/DataHubTable";
import { useDataHubCustomers } from "./hooks";
import React from "react";
import { string, func, object } from "prop-types";

interface DatahubCustomersProps {
  view?: string;
  setView?: (view: string) => void;
  setSelectedItem?: (item: any) => void;
  selectedItem?: any;
  gettext?: (key: string) => string;
}

const DatahubCustomers = (props: DatahubCustomersProps) => {
  const { view, setView, setSelectedItem, selectedItem, gettext } = props;
  const { customersList, loading } = useDataHubCustomers();

  return (
    <Grid>
      <DataHubTable
        title="Companies"
        setView={setView}
        view={view}
        rows={customersList}
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        gettext={gettext}
        loading={loading}
      />
    </Grid>
  );
};
export default DatahubCustomers;

DatahubCustomers.propTypes = {
  view: string,
  setView: func,
  setSelectedItem: func,
  selectedItem: object,
  gettext: func,
};
